import { styled } from '@mui/system';
import { COLORS } from '~/data/ui/colors';

export const CircleCountWidget = styled('div')({
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: COLORS.primary.main,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: COLORS.black.main,
  fontSize: '16px',
});
